import React, { useMemo } from "react";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ScheduleCard from "./ScheduleCard";
import Hidden from "@material-ui/core/Hidden";
import Pagination from "@material-ui/lab/Pagination";
import { useRouter } from "next/router";

const Schedules: React.FC<SchedulesProps> = (props) => {
  const router = useRouter();

  //formating event schema
  const eventSchema = useMemo(() => {
    return props.schedules.map((item) => ({
      "@context": "https://schema.org",
      "@type": "EducationEvent",
      name: item.schedule_title,
      description:
        "Enroll in PMP Certification Training Course from expert practitioners to pass the PMP exam on your 1st attempt with best practices highlighted in the PMBOK Guide.",
      performer: "Spoclearn",
      organizer: {
        name: "Spoclearn",
        url: "https://www.spoclearn.com/",
      },
      image:
        "https://spocleads.com/_next/image?url=https%3A%2F%2Fadmin.spocleads.com%2Fstorage%2Fimages%2FimageUrl_PMI%20Logo_1645091096.svg&w=1920&q=75",
      eventAttendanceMode: "https://schema.org/OnlineEventAttendanceMode",
      eventStatus: "https://schema.org/EventScheduled",
      location: {
        "@type": "VirtualLocation",
        url: process.env.NEXT_PUBLIC_APP_URL + router.asPath,
      },
      offers: {
        "@type": "AggregateOffer",
        lowPrice: item.sellingPrice,
        highPrice: item.strikOutPrice,
        url: process.env.NEXT_PUBLIC_APP_URL + router.asPath,
        availability: "https://schema.org/InStock",
        validFrom: "2022-03-20",
        price: item.strikOutPrice,
        priceCurrency: item.currencyCode,
      },
      startDate: item.startDate,
      endDate: item.endDate,
      url: process.env.NEXT_PUBLIC_APP_URL + router.asPath,

      duration: `${item.hours} Hours`,
    }));
  }, [props, router.asPath]);

  if (props.loading) {
    return <p>Loading....</p>;
  }
  if (!props.schedules || props.schedules.length === 0) {
    return <p>Events not found!</p>;
  }

  return (
    <Box pt={3}>
      {/* Header */}
      <Hidden smDown>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 500 }} component="b">
              Dates
            </Typography>
          </Grid>
          {/* <Grid item xs={2}>
            <Typography style={{ fontWeight: 500 }} component="b">
              Hours
            </Typography>
          </Grid> */}
          <Grid item xs={2}>
            <Typography style={{ fontWeight: 500 }} component="b">
              Learners
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Box textAlign="center">
              <Typography style={{ fontWeight: 500 }} component="b">
                Price
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Hidden>
      {/* Schedule Card */}
      <Box pt={2}>
        {props.schedules.map((item, index) => {
          const fastFilling = index === 0 ? item.fastFilling : "";
          const sellingPrice =
            index === 0 ? item.sellingPrice : item.strikOutPrice;
          const strikOutPrice = index === 0 ? item.strikOutPrice : "";

          return (
            <ScheduleCard
              key={index}
              dates={item.dates}
              mode={item.mode}
              month={item.month}
              sellingPrice={sellingPrice}
              strikOutPrice={strikOutPrice}
              serviceLevel={item.serviceLevel}
              timing={item.timing}
              currencyCode={item.currencyCode}
              serviceId={item.serviceId}
              scheduleId={item.scheduleId}
              scheduleDetailId={item.scheduleDetailId}
              fastFilling={fastFilling}
              eventSchema={eventSchema[index]}
              startMonth={item.startMonth}
              endMonth={item.endMonth}
              isSameYear={item.isSameYear}
            />
          );
        })}

        <Box display="flex" alignItems="center" justifyContent="center">
          <Pagination
            count={props.totalPage}
            onChange={props.handlePageChange}
            page={props.currentPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Schedules;
